import request from '@/utils/request'

// 详情页--详情
export function findDeviceInfo(params) {
  if (!params.myToken) {
    return request({
      url: '/v3/report/findDeviceInfo',
      method: 'post',
      headers: { 'token': 'nmamtf' },
      data: params
    })
  } else {
    return request({
      url: '/v3/report/findDeviceInfo',
      method: 'post',
      data: params
    })
  }
}

// 获取设备的最后位置信息
export function getGNSSLastByMcuID(params) {
  if (!params.myToken) {
    return request({
      url: '/v3/location/getGNSSLastByMcuID',
      method: 'post',
      headers: { 'token': 'nmamtf' },
      data: params
    })
  } else {
    return request({
      url: '/v3/location/getGNSSLastByMcuID',
      method: 'post',
      data: params
    })
  }
}
// 逆电器配置信息--查看
export function getIvtCfg(params) {
  return request({
    url: '/v3/device/mqtt/getIvtCfg',
    method: 'get',
    params: params
  })
}
// 逆电器配置信息--提交
export function setIvtCfg(params) {
  return request({
    url: '/v3/device/mqtt/setIvtCfg',
    method: 'post',
    data: params
  })
}
